import { render } from "./BarbieBarbieTalentList.vue?vue&type=template&id=7d081f2d&scoped=true&ts=true&lang=pug"
import script from "./BarbieBarbieTalentList.vue?vue&type=script&lang=ts"
export * from "./BarbieBarbieTalentList.vue?vue&type=script&lang=ts"

import "./BarbieBarbieTalentList.vue?vue&type=style&index=0&id=7d081f2d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d081f2d"]])

export default __exports__